<!-- Desktop HTML -->
<div *ngIf='screenWidth > 1230'>
  <!-- <div class="visible-lg" (window:orientationchange)="screenRotate($event)"> -->

  <div (window:orientationchange)="screenRotate($event)">
    <div class="flex-container">
      <div class="flex-23"></div>
      <div class="flex-53" style="margin-bottom:80px">
        <div class="flex-container">
          <div class="flex-25"></div>
          <div class="flex-container flex space-around-center">
            <div [ngClass]='{"bmw-active-link": isShowAll && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"),
            "mini-active-link": isShowAll && APP_SETTINGS.isMINI === "true",
           "rr-active-link": isShowAll && APP_SETTINGS.isRollsRoyce === "true"}'
              class="pointer" style="padding-bottom: 20px" (click)='showAll()'>ALL</div>
            <div [ngClass]='{"bmw-active-link": isShowNew && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"),
            "mini-active-link": isShowNew && APP_SETTINGS.isMINI === "true",
            "rr-active-link": isShowNew && APP_SETTINGS.isRollsRoyce === "true"}'
              class="pointer" style="padding-bottom: 20px" (click)='showNew()'>
              NEW
              <div class="badge" *ngIf="newDocsCount>0" [ngStyle]='{"background-color":(APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" :"#1c69d4"}'>{{newDocsCount}}</div>
            </div>
            <div [ngClass]='{"bmw-active-link": isShowHistory && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true")
            , "mini-active-link": isShowHistory && APP_SETTINGS.isMINI === "true",
            "rr-active-link": isShowHistory && APP_SETTINGS.isRollsRoyce === "true"}'
              class="pointer" style="padding-bottom: 20px" (click)='showHistory()'>HISTORY</div>
          </div>
          <div class="flex-25"></div>
        </div>
        <div class="bmw-lg-equip-manual-content">
          <div class="flex-container" style="padding:26px 18px 16px 18px">
            <div class="bmw-lg-equip-manual-title flex-60">Workshop Equipment</div>
            <div class="flex"></div>
            <div class="flex-35">
              <form class="input-group" name="findDocs">
                <input type="text" size=15 style="height:34px;font-size:16px;width: 100%" placeholder="Find Document" name="equipManual"
                  [(ngModel)]="search4Manuals">
                <div class="input-group-btn">
                  <button [ngClass]="{'mini-button-style' : APP_SETTINGS.isMINI === 'true', 'bmw-button-style': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true'),
                  'rr-button-style' : APP_SETTINGS.isRollsRoyce === 'true'}" class="btn btn-default"
                    type="submit">
                    <i class="glyphicon glyphicon-search"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div class="alert alert-warning" role="alert" *ngIf='errorMessage?.length > 0'>{{errorMessage}}</div>
          <div *ngIf='equipmentManuals?.length > 0'>
            <div *ngFor='let manual of equipmentManuals'>
              <div style="margin-bottom: 50px">
                <div class="bmw-equip-manual-title">{{manual?.title}}</div>
                <div class="bmw-lg-equip-manual-doc" *ngFor='let doc of manual?.content | searchFilter: "documentTitle": search4Manuals'>
                  <a [href]="(doc?.documentFileName!=null && doc?.documentFileName?.startsWith('http')) ? doc?.documentFileName : 'http://'+ doc?.documentFileName" target="_blank" *ngIf='doc.attachmentType === "Link"' (click)='saveToHistory(isShowHistory, doc?.id, doc?.documentTitle)' >
                    <div class="flex-container flex-align-center">
                      <div class="flex">{{doc?.documentTitle}}</div>
                      <div class="flex-8" style="text-align: right">
                        <i class="material-icons" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" :"#1c69d4"}'>link </i>
                      </div>
                    </div>
                  </a>
                  <a href='mount/equipment_manual/{{doc?.documentFileName}}' *ngIf='doc.documentFileType !== "zip" && doc.documentFileType !== "exe" && doc.attachmentType !== "Link"' target="_blank" (click)='saveToHistory(isShowHistory, doc?.id, doc?.documentTitle)'>
                    <div class="flex-container flex-align-center">
                      <div class="flex">{{doc?.documentTitle}}</div>
                      <div class="flex-8" style="text-align: right">
                        <i class="material-icons" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" :"#1c69d4"}'>
                          {{ (doc.documentFileType | lowercase) === "pdf" ? "picture_as_pdf" : "insert_drive_file"}}
                        </i>
                      </div>
                    </div>
                  </a>
                  <a href='mount/equipment_manual/{{doc?.documentFileName}}' *ngIf='(doc.documentFileType | lowercase) === "zip" || (doc.documentFileType | lowercase) === "exe"  && doc.attachmentType !== "Link"' (click)='saveToHistory(isShowHistory, doc?.id, doc?.documentTitle)' download>
                    <div class="flex-container flex-align-center">
                      <div class="flex">{{doc?.documentTitle}}</div>
                      <div class="flex-8" style="text-align: right">
                        <i class="material-icons" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" :"#1c69d4"}'>file_download </i>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex"></div>
    </div>
  </div>
</div>
<!-- Ipad Pro HTML -->
<div *ngIf='screenWidth >= 991 && screenWidth <= 1230'>
  <!-- <div class="visible-md" (window:orientationchange)="screenRotate($event)"> -->

  <div (window:orientationchange)="screenRotate($event)">
    <div class="flex-container">
      <div class="flex"></div>
      <div class="flex-70" style="margin-bottom:80px">
        <div class="flex-container">
          <div class="flex-20"></div>
          <div class="flex-container flex space-around-center">
            <div [ngClass]='{"bmw-active-link": isShowAll && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"),
            "mini-active-link": isShowAll && APP_SETTINGS.isMINI === "true",
           "rr-active-link": isShowAll && APP_SETTINGS.isRollsRoyce === "true"}'
              class="pointer" style="padding-bottom: 20px" (click)='showAll()'>ALL</div>
            <div [ngClass]='{"bmw-active-link": isShowNew && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"),
            "mini-active-link": isShowNew && APP_SETTINGS.isMINI === "true",
            "rr-active-link": isShowNew && APP_SETTINGS.isRollsRoyce === "true"}'
              class="pointer" style="padding-bottom: 20px" (click)='showNew()'>
              NEW
              <div class="badge" *ngIf="newDocsCount>0" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" :"#1c69d4"}'>{{newDocsCount}}</div>
            </div>
            <div [ngClass]='{"bmw-active-link": isShowHistory && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true")
            , "mini-active-link": isShowHistory && APP_SETTINGS.isMINI === "true",
            "rr-active-link": isShowHistory && APP_SETTINGS.isRollsRoyce === "true"}'
              class="pointer" style="padding-bottom: 20px" (click)='showHistory()'>HISTORY</div>
          </div>
          <div class="flex-20"></div>
        </div>
        <div class="bmw-lg-equip-manual-content">
          <div class="flex-container" style="padding:26px 18px 16px 18px">
            <div class="bmw-lg-equip-manual-title flex-60">Workshop Equipment</div>
            <div class="flex"></div>
            <div class="flex-34">
              <form class="input-group" name="findDocs">
                <input type="text" size=15 style="height:34px;font-size:16px;width: 100%" placeholder="Find Document" name="equipManual"
                  [(ngModel)]="search4Manuals">
                <div class="input-group-btn">
                  <button [ngClass]="{'mini-button-style' : APP_SETTINGS.isMINI === 'true', 'bmw-button-style': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true'),
                  'rr-button-style' : APP_SETTINGS.isRollsRoyce === 'true'}" class="btn btn-default"
                    type="submit">
                    <i class="glyphicon glyphicon-search"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div *ngFor='let manual of equipmentManuals'>
            <div style="margin-bottom: 50px">
              <div class="bmw-equip-manual-title">{{manual?.title}}</div>
              <div class="bmw-lg-equip-manual-doc" *ngFor='let doc of manual?.content | searchFilter: "documentTitle": search4Manuals'>
                <a href='mount/equipment_manual/{{doc?.documentFileName}}' target="_blank" (click)='saveToHistory(isShowHistory, doc?.id, doc?.documentTitle)'>
                  <div class="flex-container flex-align-center">
                    <div class="flex">{{doc?.documentTitle}}</div>
                    <div class="flex-8" style="text-align: right">
                      <i class="material-icons" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" :"#1c69d4"}'>
                        {{ doc.documentFileType === "pdf" ? "picture_as_pdf" : (doc.documentFileType === "zip" || doc.documentFileType === "exe")
                        ? "file_download" : doc.documentFileType === "xlsx" ? "insert_drive_file" : "" }}
                      </i>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex"></div>
    </div>
  </div>
</div>

<!-- Ipad HTML -->
<div *ngIf='screenWidth >= 767 && screenWidth <= 991'>
  <!-- <div class="visible-sm" (window:orientationchange)="screenRotate($event)"> -->

  <div (window:orientationchange)="screenRotate($event)">
    <div class="flex-container">
      <div class="flex-20"></div>
      <div class="flex-container flex space-around-center">
        <div [ngClass]='{"bmw-active-link": isShowAll && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"),
        "mini-active-link": isShowAll && APP_SETTINGS.isMINI === "true",
       "rr-active-link": isShowAll && APP_SETTINGS.isRollsRoyce === "true"}'
          class="pointer" style="padding-bottom: 20px" (click)='showAll()'>ALL</div>
        <div [ngClass]='{"bmw-active-link": isShowNew && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"),
        "mini-active-link": isShowNew && APP_SETTINGS.isMINI === "true",
        "rr-active-link": isShowNew && APP_SETTINGS.isRollsRoyce === "true"}'
          class="pointer" style="padding-bottom: 20px" (click)='showNew()'>
          NEW
          <div class="badge" *ngIf="newDocsCount>0" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" :"#1c69d4"}'>{{newDocsCount}}</div>
        </div>
        <div [ngClass]='{"bmw-active-link": isShowHistory && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true")
        , "mini-active-link": isShowHistory && APP_SETTINGS.isMINI === "true",
        "rr-active-link": isShowHistory && APP_SETTINGS.isRollsRoyce === "true"}'
          class="pointer" style="padding-bottom: 20px" (click)='showHistory()'>HISTORY</div>
      </div>
      <div class="flex-20"></div>
    </div>
    <div class="bmw-sm-takata-content">
      <div class="flex-container" style="padding:26px 18px 16px 18px">
        <div class="bmw-lg-equip-manual-title flex-60" style="font-size:30px">Workshop Equipment</div>
        <div class="flex"></div>
        <div class="flex-30">
          <form class="input-group" name="findDocs" style="width: 100%">
            <input type="text" class="form-control" size=15 style="height:34px;font-size:16px;" placeholder="Find Document" name="equipManual"
              [(ngModel)]="search4Manuals">
            <div class="input-group-btn">
              <button [ngClass]="{'mini-button-style' : APP_SETTINGS.isMINI === 'true', 'bmw-button-style': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true'),
              'rr-button-style' : APP_SETTINGS.isRollsRoyce === 'true'}" class="btn btn-default"
                type="submit">
                <i class="glyphicon glyphicon-search"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
      <div *ngFor='let manual of equipmentManuals'>
        <div style="margin-bottom: 50px">
          <div class="bmw-equip-manual-title">{{manual?.title}}</div>
          <div class="bmw-lg-equip-manual-doc" *ngFor='let doc of manual?.content | searchFilter: "documentTitle": search4Manuals'>
            <a href='mount/equipment_manual/{{doc?.documentFileName}}' target="_blank" (click)='saveToHistory(isShowHistory, doc?.id, doc?.documentTitle)'>
              <div class="flex-container flex-align-center">
                <div class="flex">{{doc?.documentTitle}}</div>
                <div class="flex-8" style="text-align: right">
                  <i class="material-icons" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" :"#1c69d4"}'>
                    {{ doc.documentFileType === "pdf" ? "picture_as_pdf" : (doc.documentFileType === "zip" || doc.documentFileType === "exe")
                    ? "file_download" : doc.documentFileType === "xlsx" ? "insert_drive_file" : "" }}
                  </i>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Mobile HTML -->
<div *ngIf='screenWidth > 319 && screenWidth < 767'>
  <!-- <div class="xs-visible" (window:orientationchange)="screenRotate($event)"> -->

  <div (window:orientationchange)="screenRotate($event)">
    <div class="flex-container">
      <div class="flex-container flex space-around-center">
        <div [ngClass]='{"bmw-active-link": isShowAll && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"),
        "mini-active-link": isShowAll && APP_SETTINGS.isMINI === "true",
       "rr-active-link": isShowAll && APP_SETTINGS.isRollsRoyce === "true"}'
          class="pointer" style="padding-bottom: 20px" (click)='showAll()'>ALL</div>
        <div [ngClass]='{"bmw-active-link": isShowNew && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"),
        "mini-active-link": isShowNew && APP_SETTINGS.isMINI === "true",
        "rr-active-link": isShowNew && APP_SETTINGS.isRollsRoyce === "true"}'
          class="pointer" style="padding-bottom: 20px" (click)='showNew()'>
          NEW
          <div class="badge" *ngIf="newDocsCount>0" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" :"#1c69d4"}'>{{newDocsCount}}</div>
        </div>
        <div [ngClass]='{"bmw-active-link": isShowHistory && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true")
        , "mini-active-link": isShowHistory && APP_SETTINGS.isMINI === "true",
        "rr-active-link": isShowHistory && APP_SETTINGS.isRollsRoyce === "true"}'
          class="pointer" style="padding-bottom: 20px" (click)='showHistory()'>HISTORY</div>
      </div>
    </div>
    <div class="bmw-xs-takata-content">
      <div style="padding:26px 18px 16px 18px">
        <div class="bmw-lg-equip-manual-title" style="font-size:24px; text-align: center;margin-bottom: 10px">Workshop Equipment</div>
        <div>
          <form class="input-group" name="findDocs" style="width: 100%">
            <input type="text" class="form-control" size=15 style="height:34px;font-size:16px;" placeholder="Find Document" name="equipManual"
              [(ngModel)]="search4Manuals">
            <div class="input-group-btn">
              <button [ngClass]="{'mini-button-style' : APP_SETTINGS.isMINI === 'true', 'bmw-button-style': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true'),
              'rr-button-style' : APP_SETTINGS.isRollsRoyce === 'true'}" class="btn btn-default"
                type="submit">
                <i class="glyphicon glyphicon-search"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
      <div *ngFor='let manual of equipmentManuals'>
        <div style="margin-bottom: 50px">
          <div class="bmw-equip-manual-title" style="text-align: center">{{manual?.title}}</div>
          <div class="bmw-lg-equip-manual-doc" *ngFor='let doc of manual?.content | searchFilter: "documentTitle": search4Manuals'>
            <a href='mount/equipment_manual/{{doc?.documentFileName}}' target="_blank" (click)='saveToHistory(isShowHistory, doc?.id, doc?.documentTitle)'>
              <div class="flex-container flex-align-center">
                <div class="flex">{{doc?.documentTitle}}</div>
                <div class="flex-8" style="text-align: right">
                  <i class="material-icons" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" :"#1c69d4"}'>
                    {{ doc.documentFileType === "pdf" ? "picture_as_pdf" : (doc.documentFileType === "zip" || doc.documentFileType === "exe")
                    ? "file_download" : doc.documentFileType === "xlsx" ? "insert_drive_file" : "" }}
                  </i>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>